const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideotablegames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#870600"
    },
    d: "M160,293.6c0,5.6-4.8,10.4-10.4,10.4H10.4C4.8,304,0,299.2,0,293.6V34.4C0,28.8,4.8,24,10.4,24h139.2 c5.6,0,10.4,4.8,10.4,10.4V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43D27"
    },
    d: "M144,274.4c0,4-7.2,5.6-11.2,5.6h-108c-4,0-8.8-0.8-8.8-5.6V56c0-4,4.8-8,8.8-8h108 c4,0,11.2,4,11.2,8V274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA241A"
    },
    d: "M16,56c0-4,4.8-8,8.8-8h108c4,0,11.2,4,11.2,8v218.4c0,4-5.6,8-9.6,8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE9DA"
    },
    d: "M50.4,116.8c12,0,21.6,6.4,25.6,16c0,0.8,1.6,1.6,2.4,1.6s2.4,0,2.4-1.6c4-9.6,13.6-16,25.6-16 c15.2,0,27.2,10.4,27.2,24c0,4.8-1.6,9.6-4.8,13.6l0,0l0,0l-50.4,59.2L28,154.4l0,0l0,0c-3.2-4-4.8-8.8-4.8-13.6 C23.2,128,36,116.8,50.4,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C6B1"
    },
    d: "M78.4,134.4c0.8,0,2.4,0,2.4-1.6c4-9.6,13.6-16,25.6-16c15.2,0,27.2,10.4,27.2,24 c0,4.8-1.6,9.6-4.8,13.6l0,0l0,0l-50.4,59.2 M28,154.4L28,154.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A1E1E"
    },
    d: "M272,461.6c0,5.6-4.8,10.4-10.4,10.4H122.4c-5.6,0-10.4-4.8-10.4-10.4V202.4 c0-5.6,4.8-10.4,10.4-10.4h139.2c5.6,0,10.4,4.8,10.4,10.4L272,461.6L272,461.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A514F"
    },
    d: "M256,440c0,4-7.2,8-11.2,8h-108c-4,0-8.8-4-8.8-8V221.6c0-4,4.8-5.6,8.8-5.6h108 c4,0,11.2,0.8,11.2,5.6V440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393F3D"
    },
    d: "M128.8,222.4c0-4,3.2-6.4,8-6.4h108c4,0,11.2,0.8,11.2,5.6V440c0,4-7.2,8-11.2,8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE9DA"
    },
    d: "M241.6,328C240.8,328,240.8,328,241.6,328C240.8,328,240.8,328,241.6,328l-50.4-60l-50.4,60l0,0l0,0 c-3.2,4-4.8,8.8-4.8,13.6c0,12.8,12,24,27.2,24c8.8,0,16-4,21.6-9.6l-8.8,36h13.6h2.4h13.6l-8-36c4.8,5.6,12.8,9.6,21.6,9.6 c15.2,0,27.2-10.4,27.2-24C245.6,336.8,244,332,241.6,328z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C6B1"
    },
    d: "M190.4,392L190.4,392h15.2l-8-36c4.8,5.6,12.8,9.6,21.6,9.6c15.2,0,27.2-10.4,27.2-24 c0-4.8-1.6-9.6-4.8-13.6l0,0l0,0l-50.4-59.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#870600"
    },
    d: "M384,293.6c0,5.6-4.8,10.4-10.4,10.4H234.4c-5.6,0-10.4-4.8-10.4-10.4V34.4c0-5.6,4.8-10.4,10.4-10.4 h139.2c5.6,0,10.4,4.8,10.4,10.4V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43D27"
    },
    d: "M368,274.4c0,4-4.8,5.6-8.8,5.6h-108c-4,0-11.2-0.8-11.2-5.6V56c0-4,7.2-8,11.2-8h108 c4,0,8.8,4,8.8,8V274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA241A"
    },
    d: "M240,56c0-4,7.2-8,11.2-8h108c4,0,8.8,4,8.8,8v218.4c0,4-4,8-8,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAE9DA"
    },
    points: "345.6,165.6 305.6,220 264.8,165.6 305.6,110.4 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#C9C6B1"
    },
    points: "305.6,110.4 345.6,165.6 305.6,220 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A1E1E"
    },
    d: "M496,461.6c0,5.6-4.8,10.4-10.4,10.4H346.4c-5.6,0-10.4-4.8-10.4-10.4V202.4 c0-5.6,4.8-10.4,10.4-10.4h139.2c5.6,0,10.4,4.8,10.4,10.4L496,461.6L496,461.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A514F"
    },
    d: "M480,440c0,4-4.8,8-8.8,8h-108c-4,0-11.2-4-11.2-8V221.6c0-4,7.2-5.6,11.2-5.6h108 c4,0,8.8,0.8,8.8,5.6V440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393F3D"
    },
    d: "M352,221.6c0-4,7.2-5.6,11.2-5.6h108c4,0,8.8,0.8,8.8,5.6V440c0,4-4.8,8-8.8,8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE9DA"
    },
    d: "M430.4,352.8l23.2-1.6l0,0c3.2,0,6.4-0.8,8.8-2.4c10.4-5.6,15.2-18.4,9.6-29.6 c-5.6-10.4-18.4-15.2-29.6-9.6c-0.8,0.8-2.4,1.6-3.2,2.4l0.8-2.4l0,0c1.6-3.2,2.4-6.4,2.4-10.4c0-14.4-11.2-25.6-25.6-25.6 S392,284,392,298.4c0,4,0.8,7.2,2.4,10.4l0,0l0.8,2.4c-0.8-0.8-1.6-1.6-3.2-2.4c-10.4-5.6-24-1.6-29.6,9.6 c-5.6,10.4-1.6,24,9.6,29.6c3.2,1.6,5.6,2.4,8.8,2.4l0,0L404,352"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EAE9DA"
    },
    points: "380.8,351.2 380.8,351.2 404,352.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C6B1"
    },
    d: "M417.6,272c14.4,0,25.6,12,25.6,25.6c0,4-0.8,7.2-2.4,10.4l0,0l-0.8,2.4c0.8-0.8,2.4-1.6,3.2-2.4 c10.4-5.6,24-1.6,29.6,9.6c5.6,10.4,1.6,24-9.6,29.6c-3.2,1.6-5.6,2.4-8.8,2.4l0,0l-23.2,1.6H416"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAE9DA"
    },
    points: "408,368 402.4,392 416,392 419.2,392 432,392 427.2,368  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#C9C6B1"
    },
    points: "416,392 419.2,392 432,392 427.2,368 416,368 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideotablegames);
export default __webpack_public_path__ + "static/media/video table games.8eaa911d3ab0d247a63e201620d2a8fe.svg";
export { ForwardRef as ReactComponent };